// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._container ._abstract ._key{$c:var(--var-color)}._container ._abstract ._number{$c:var(--number-color)}._container ._abstract ._null{$c:var(--operator-color)}._container ._abstract ._string{$c:var(--string-color)}._container ._abstract ._boolean{$c:var(--keyword-color)}._container ._abstract ._special{$c:var(--operator-color)}", ""]);
// Exports
module.exports = exports;
